import createReactClass from 'create-react-class';
('use strict');

// Import Libraries
import React from 'react';
import flattenDeep from 'lodash/flattenDeep';
// Import JS Modules
import Currency from '../_utils/tools/currency';
import translate from '../_utils/tools/translate';
import classNames from 'classnames';
import QuantityPricingTools from './quantity-pricing-tools';

// -----------------------------------------------------------
//  PricesTable
// -----------------------------------------------------------
const PricesTable = createReactClass({
  shouldComponentUpdate(nextProps, nextState) {
    return false;
  },

  render() {
    const groupedDeliveryOptions = this.groupedDeliveryOptions(),
      allDeliveryOptions = this.allDeliveryOptions(groupedDeliveryOptions),
      oneHourEnabled = (allDeliveryOptions[0] || {}).code == 'RA',
      deliveryDescriptionRA = oneHourEnabled
        ? formatDeliveryDescription(
            this.props.deliveryDescriptionRA,
            <span>
              Ready in as soon as <br />
              1-Hour
            </span>,
          )
        : formatDeliveryDescription(
            this.props.deliveryDescriptionRA1,
            <span>Ready for {translate('pick-up')} today</span>,
          ),
      deliveryDescriptionUFC = this.props.deliveryDescriptionUFC;

    return (
      <div className="table-responsive">
        <table
          className={classNames(
            'table table-striped-manual table-item-prices',
            { 'table-bordered': this.props.showBorders },
          )}>
          <thead>
            <tr className="table-horizontal-separator striped-row">
              <td className="table-vertical-separator"></td>
              <td colSpan="2" className="table-vertical-separator">
                <h6>
                  <strong>{this.props.deliveryTitleRA || 'Same Day'}</strong>
                </h6>
                <p>{deliveryDescriptionRA}</p>
              </td>
              <td colSpan="2">
                <h6>
                  <strong>Home Delivery</strong>
                </h6>
                <p>{deliveryDescriptionUFC}</p>
              </td>
            </tr>
            <tr>
              <td className="table-vertical-separator">
                <h6>Sizes</h6>
              </td>
              <td>
                <h6>Qty</h6>
              </td>
              <td className="table-vertical-separator">
                <h6>Price (ea)</h6>
              </td>
              <td>
                <h6>Qty</h6>
              </td>
              <td className="table-vertical-separator">
                <h6>Price (ea)</h6>
              </td>
            </tr>
          </thead>
          <tbody>{this.props.products.map(renderProduct, this)}</tbody>
        </table>
      </div>
    );

    function renderProduct(product, i) {
      const quantityPricingTools = new QuantityPricingTools(product),
        $rows = [],
        maxPriceBreaks = maxPriceBreaksForProduct(product);

      for (let j = 0; j < maxPriceBreaks; j++) {
        const $additionalPriceColumns = renderAdditionalPagesPriceColumns(
          product,
          quantityPricingTools,
        );

        $rows.push(
          <tr className={classNames({ 'striped-row': i % 2 == 0 })} key={i + j}>
            {renderProductColumns(
              product,
              j,
              maxPriceBreaks,
              !!$additionalPriceColumns,
            )}
          </tr>,
        );

        if ($additionalPriceColumns) {
          $rows.push(
            <tr
              className={classNames('additional-pages-price', {
                'striped-row': i % 2 == 0,
              })}
              key={'additional-pages-price' + i + j}>
              {$additionalPriceColumns}
            </tr>,
          );
        }
      }

      return $rows;
    }

    function renderProductColumns(
      product,
      breakIndex,
      maxPriceBreaks,
      hasAdditionalPriceRows,
    ) {
      const $columns = [];

      if (breakIndex == 0) {
        $columns.push(
          <td
            rowSpan={maxPriceBreaks}
            key="product-title"
            className={classNames({ 'pb-0': hasAdditionalPriceRows })}>
            {product.title}
          </td>,
        );
      }

      groupedDeliveryOptions.forEach((deliveryOptionGroup, i) => {
        let qty = '-',
          price = '-',
          rowSpan = maxPriceBreaks,
          prices;

        deliveryOptionGroup.forEach((deliveryOption) => {
          prices || (prices = product.delivery_prices[deliveryOption.key]);
        });

        if (prices) {
          const currentBreak = prices[breakIndex];
          if (!currentBreak) {
            return;
          }

          if (prices.length > 1) {
            rowSpan = 1;
          }

          price = Currency.format(currentBreak.price);

          if (breakIndex < prices.length - 1) {
            qty = currentBreak.break + '-' + (prices[breakIndex + 1].break - 1);
          } else {
            qty = currentBreak.break + '+';
          }
        } else if (breakIndex > 0) {
          return;
        }

        $columns.push(
          <td
            suppressHydrationWarning={true}
            rowSpan={rowSpan}
            className="pb-0"
            key={'qty' + i}>
            {qty}
          </td>,
        );
        $columns.push(
          <td rowSpan={rowSpan} className="pb-0" key={'price' + i}>
            {price}
          </td>,
        );
      });

      return $columns;
    }

    function maxPriceBreaksForProduct(product) {
      let maxPriceBreaksForProduct = 1;

      for (let i = 0; i < allDeliveryOptions.length; i++) {
        const prices =
          (allDeliveryOptions[i] &&
            product.delivery_prices[allDeliveryOptions[i].key]) ||
          [];
        if (prices.length > maxPriceBreaksForProduct) {
          maxPriceBreaksForProduct = prices.length;
        }
      }

      return maxPriceBreaksForProduct;
    }

    function formatDeliveryDescription(deliveryDescription, fallback) {
      if (typeof deliveryDescription != 'undefined') return deliveryDescription;

      if (typeof fallback == 'function') return fallback();

      return fallback;
    }

    function renderAdditionalPagesPriceColumns(product, quantityPricingTools) {
      const $columns = [];
      let includeRow = false;

      $columns.push(
        <td className="pt-0" key="title">
          Each Additional Page
        </td>,
      );

      groupedDeliveryOptions.forEach((deliveryOptionGroup, i) => {
        deliveryOptionGroup.forEach((deliveryOption) => {
          const extraPagePrice =
            (product.delivery_prices[deliveryOption.key] || []).length &&
            quantityPricingTools.getExtraPagePrice(deliveryOption);

          $columns.push(
            <td className="pt-0" key={'dash-qtty-replacer' + i}>
              {extraPagePrice ? '' : '-'}
            </td>,
          );
          if (extraPagePrice) {
            $columns.push(
              <td className="pt-0" key={'additional-price' + i}>
                {Currency.format(extraPagePrice)}
              </td>,
            );
            includeRow = true;
          } else {
            $columns.push(
              <td className="pt-0" key={'dash-additional-price-replacer' + i}>
                -
              </td>,
            );
          }
        });
      });

      return includeRow ? $columns : null;
    }
  },

  groupedDeliveryOptions() {
    const { delivery_options: deliveryOptions } = this.props;
    let oneHourDeliveryOption, sameDayDeliveryOption, homeDeliveryOption;

    for (let i = 0; i < deliveryOptions.length; i++) {
      switch (deliveryOptions[i].code) {
        case 'RA':
          oneHourDeliveryOption = deliveryOptions[i];
          break;
        case 'RA1':
          sameDayDeliveryOption = deliveryOptions[i];
          break;
        case 'UFC':
          homeDeliveryOption = deliveryOptions[i];
          break;
      }
    }

    return [
      [oneHourDeliveryOption, sameDayDeliveryOption],
      [homeDeliveryOption],
    ].map((group) => group.filter(Boolean)); // remove empty items, leave empty groups
  },

  allDeliveryOptions(groupedDeliveryOptions) {
    return flattenDeep(groupedDeliveryOptions).filter(Boolean);
  },
});

export default PricesTable;
